module.exports = __webpack_public_path__ + "static/fipcwhiteelephant4-04b5246f83fbecb8d8544eba65e29ef5.jpeg";